import { Trans } from '@lingui/react/macro';
import { ColumnChartIcon } from '@intercom/surge/icons';

export const EmptyStateChart = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-48 px-6 py-8">
      <ColumnChartIcon className="w-16 h-16 text-support mb-4" />
      <h2 className="text-base font-semibold text-default mb-2 text-center">
        <Trans>This chart has no data</Trans>
      </h2>
    </div>
  );
};
